import * as Yup from 'yup';

export const ProcessFormValidationSchema = Yup.object().shape({
  PositionTitle: Yup.string()
    .max(150, 'You have exceeded the maximum number of 150 characters')
    .required('Title field is required'),

  AboutUs: Yup.object()
    .test(
      'is-empty',
      'About us field is required',
      value => value && value.getCurrentContent().hasText()
    )
    .test(
      'max-length',
      'You have exceeded the maximum number of 2000 characters',
      value => value && value.getCurrentContent().getPlainText().length <= 2000
    ),

  Descriptions: Yup.object()
    .test(
      'is-empty',
      'Description field is required',
      value => value && value.getCurrentContent().hasText()
    )
    .test(
      'max-length',
      'You have exceeded the maximum number of 2000 characters',
      value => value && value.getCurrentContent().getPlainText().length <= 2000
    ),

  AdditionalDetails: Yup.object().test(
    'max-length',
    'You have exceeded the maximum number of 2000 characters',
    value => value && value.getCurrentContent().getPlainText().length <= 2000
  ),

  startDate: Yup.object()
    .nullable()
    .test(
      'is-startDate',
      'Start Date field is required',
      value => value && value.month && value.year
    ),

  AppDeadlineDate: Yup.date()
    .nullable()
    .when(
      ['AppDeadline', 'startDate', 'publishedOn'],
      (AppDeadline, startDate, publishedOn, schema) => {
        if (!AppDeadline) {
          return schema;
        }

        return schema
          .test(
            'compare-AppDeadlineDate-startDate',
            'Application Deadline Date should be less than Start Date',
            value => {
              if (!startDate.year || !startDate.month || !value) {
                return false;
              }

              const sDate = new Date(startDate.year, startDate.month, 1);
              sDate.setDate(sDate.getDate() - 1);

              const cDate = new Date(value);
              cDate.setHours(0);
              cDate.setMinutes(0);
              cDate.setSeconds(0);

              return cDate <= sDate;
            }
          )
          .test(
            'compare-AppDeadlineDate-postDate',
            'Application deadline should not less than job post date',
            value => {
              const sDate = new Date(publishedOn);
              sDate.setDate(sDate.getDate() - 1);
              return new Date(value) >= sDate;
            }
          );
      }
    ),

  EmailTemplateFollowupID: Yup.object()
    .nullable()
    .when(['hasFollowUpEmail'], (hasFollowUpEmail, schema) => {
      return hasFollowUpEmail
        ? schema.test(
          'is-empty',
          'Please select a template',
          value => value && value.value
        )
        : schema;
    }),
  ATSLink: Yup.string()
    .nullable()
    .when(['hasATSLink'], (hasATSLink, schema) => {
      return hasATSLink
        ? schema
          .max(512, 'You have exceeded the maximum number of 512 characters')
          .required('This field is required')
          .test(
            'domain-check',
            'Invalid link: allowed only "Workable", "Jotform", "Greenhouse", "Workday", "Paylocity" or "BambooHR" links',
            value => {
              const regexp = new RegExp(
                /^(http(s)?:\/\/)?(.*\.)?(recruiting.paylocity.com|workable.com|jotform.com|greenhouse.io|myworkdayjobs.com|myworkdaysite.com|bamboohr.com)?\//
              );
              return regexp.test(value);
            }
          )
        : schema;
    }),
});
